import {applyResultCart} from "@Common/logic/checkout/common/apply-result-cart";
import {getNestedValue}  from "@Common/utils/arr-path";

export const setShippingServiceLevel = (serviceLevel, {itemId=undefined, addressId=undefined, apis}) => ({
    action: async (cart) => {

        const resultCart = await apis.next.cart.updateCart({
            cartId: cart.cartId,
            "shipping": {
                ...cart.shipping,
                addressId: addressId ?? getNestedValue(cart, ["shipping", "addressId"]),
                itemId,
                serviceLevel,
            }
        });
        return {
            change: applyResultCart(resultCart),
        };
    },
});


